export default __webpack_public_path__ + "static/media/FilterBubbleMockup.cd72d7f7.webp";